import { render } from "./AdvancedConfigs.vue?vue&type=template&id=23a4bafd"
import script from "./AdvancedConfigs.vue?vue&type=script&lang=js"
export * from "./AdvancedConfigs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__